module.exports = __webpack_public_path__ + "static/img/whyItem_01.05ede17c.png";